import mongoose from 'mongoose';
import lodash from 'lodash';

const fieldSetter1 = function fieldSetter1(value, field) {
    if (value !== this.get(field.path)) {
        this.set({
            'bought_info.purchasing_team_approval.value': false,
            'bought_info.transport_team_approval.value': false,
            'bought_info.accounts_team_approval.value': false,
        });
    }

    return value;
};

const fieldSetter2 = function fieldSetter2(value, field) {
    if (value !== this.get(field.path)) {
        this.set({
            'purchasing_team_approval.value': false,
            'transport_team_approval.value': false,
            'accounts_team_approval.value': false,
        });
    }

    return value;
};

const fieldSetter3 = function fieldSetter3(value, field) {
    if (value !== this.get(field.path)) {
        this.parent().set({
            'purchasing_team_approval.value': false,
            'transport_team_approval.value': false,
            'accounts_team_approval.value': false,
        });
    }

    return value;
};

// get last changed history
const getFullName = function getFullName(user) {
    return user && `${user.person.first_name} ${user.person.last_name}`;
};

const changeSettAmountOrPurchPrice = function changeSettAmountOrPurchPrice(settAmount, purchPrice) {
    let positive_equity_amount = 0;
    let negative_equity_amount = 0;

    if (purchPrice > settAmount) {
        positive_equity_amount = purchPrice - settAmount;
    } else {
        negative_equity_amount = settAmount - purchPrice;
    }

    return { positive_equity_amount, negative_equity_amount };
};

const turnInsideOut = function turnInsideOut(action) {
    const data = this.toJSON();
    const result = {};

    const iterate = (object, prefix) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in object) {
            if (Reflect.has(object, key)) {
                const value = object[key];
                const path = prefix ? `${prefix}.${key}` : key;

                if (key === 'bought_by_driver' && value) {
                    result[path] = value._id;
                } else if (key === 'settlement_proof' && value) {
                    if (value._id) {
                        result[path] = value._id;
                    } else {
                        result[path] = {
                            base64String: value.data,
                            fileName: value.file.name,
                            fileSize: value.file.size,
                            fileType: value.file.type,
                        };
                    }
                } else if (lodash.isPlainObject(value)) {
                    iterate(value, path);
                } else {
                    result[path] = value;
                }
            }
        }

        return result;
    };

    if (action === 'Create') {
        const driverId = lodash.get(data, 'bought_info.bought_by_driver._id');
        const proof = data.settlement_proof;

        data.bought_info.bought_by_driver = driverId;

        if (proof) {
            data.settlement_proof = {
                base64String: proof.data,
                fileName: proof.file.name,
                fileSize: proof.file.size,
                fileType: proof.file.type,
            };
        }

        return data;
    }

    iterate(data);

    return result;
};

const NO_FINANCE_VALUE = 'No Finance';

export const leadFinanceSchema = new mongoose.Schema({
    ref_lead: {
        required: true,
        type: mongoose.Schema.Types.ObjectId,
    },
    finance_company: {
        displayName: 'Finance company',
        type: String,
        enum: [
            NO_FINANCE_VALUE,
            'Close Motor Finance',
            'Blackhorse',
            'Moto Novo',
            'First Response',
            'Advantage Finance',
            'Billing Finance',
            'Santander',
            'Private & Commercial',
            'Auto Accept Finance',
            'Hitachi',
            'BMW Finance',
            'First Stop',
            'Honda Finance',
            'Connister Bank',
            'Blue Motor Finance',
            'Paragon Bank PLC',
            'ALPHERA Financial Services',
            'Suzuki Finance',
            'Other',
        ],
        // eslint-disable-next-line object-shorthand
        set: function financeCompanySetter(value, field) {
            const finTree = this.schema.tree;
            const boughtTree = finTree.bought_info.type.tree;

            finTree.finance_amount.isEditable = value !== NO_FINANCE_VALUE;
            boughtTree.finance_expiry_date.isEditable = value !== NO_FINANCE_VALUE;
            finTree.finance_agreement_number.isEditable = value !== NO_FINANCE_VALUE;

            return fieldSetter1.call(this, value, field);
        },
    },
    finance_amount: {
        displayName: 'Settlement Amount',
        type: Number,
        isEditable: true,
        default: 0,
        set: function settlementAmountSetter(value, field) {
            const purchasePrice = this.get('bought_info.cash_amount');

            const {
                positive_equity_amount,
                negative_equity_amount,
            } = changeSettAmountOrPurchPrice(value, purchasePrice);

            this.set({
                'bought_info.positive_equity_amount': positive_equity_amount,
                'bought_info.negative_equity_amount': negative_equity_amount,
            });

            return fieldSetter2.call(this, value, field);
        },
    },
    finance_agreement_number: {
        displayName: 'Finance Agreement Number',
        type: String,
        isEditable: true,
        default: '',
        set: fieldSetter1,
    },
    bought_info: {
        default: {},
        type: new mongoose.Schema({
            bought_by_driver: {
                displayName: 'Driver name',
                // type: mongoose.Schema.Types.ObjectId,
                type: Object,
                get: getFullName,
                isLoading: false,
                externalData: [],
            },
            bought_date: {
                displayName: 'Bought Date',
                type: Date,
            },
            deferred_payment_amount: {
                displayName: 'Deferred Payment Amount',
                type: Number,
            },
            deferred_payment_type: {
                displayName: 'Deferred Payment Type',
                type: String,
            },
            deferred_payment_date: {
                displayName: 'Deferred Payment Date',
                type: Date,
            },
            final_agent_valuation: {
                displayName: 'Original Valuation',
                type: Number,
            },
            customer_name: {
                displayName: 'Customer Name',
                type: String,
                set: fieldSetter2,
            },
            customer_name_v5: {
                default: {},
                type: new mongoose.Schema({
                    value: {
                        displayName: 'V5 Customer Name',
                        type: String,
                        set: fieldSetter3,
                    },
                    is_locked: {
                        displayName: 'Is locked by Blemish report ?',
                        type: Boolean,
                        default: false,
                    },
                }),
            },
            // final_driver_price: {
            //     displayName: 'Final Driver Price',
            //     type: Number,
            // },
            final_purchase_price: {
                displayName: 'Final Purchase',
                type: Number,
            },
            bank_transfer_amount: {
                displayName: 'Bank Transfer',
                type: Number,
            },
            cash_amount: {
                displayName: 'Purchase price',
                // helperText: 'Leave blank if negative equity',
                default: 0,
                isEditable: false,
                type: Number,
                set: function cashAmountSetter(value, field) {
                    const settlementAmount = this.parent().get('finance_amount');

                    const {
                        positive_equity_amount,
                        negative_equity_amount,
                    } = changeSettAmountOrPurchPrice(settlementAmount, value);

                    this.set({
                        positive_equity_amount,
                        negative_equity_amount,
                    });

                    return fieldSetter2.call(this, value, field);
                },
            },
            new_retail_price: {
                displayName: 'New Retail Price',
                type: Number,
            },
            finance_expiry_date: {
                displayName: 'Settlement Valid Until',
                isEditable: true,
                type: Date,
                set: fieldSetter2,
            },
            negative_equity_amount: {
                displayName: 'Balance From Customer',
                idEditable: false,
                type: Number,
                default: 0,
                set: fieldSetter2,
            },
            positive_equity_amount: {
                displayName: 'Balance To Customer',
                idEditable: false,
                type: Number,
                default: 0,
                set: fieldSetter2,
            },
            purchasing_team_approval: {
                default: {},
                type: new mongoose.Schema({
                    value: {
                        displayName: 'Purchasing Team Approval',
                        type: Boolean,
                        default: false,
                    },
                    updated_date: {
                        displayName: 'Updated at',
                        type: Date,
                    },
                    updated_by: {
                        displayName: 'Updated by',
                        type: Object,
                        get: getFullName,
                    },
                }),
            },
            transport_team_approval: {
                default: {},
                type: new mongoose.Schema({
                    value: {
                        displayName: 'Transport Team Approval',
                        type: Boolean,
                        default: false,
                    },
                    updated_date: {
                        displayName: 'Updated at',
                        type: Date,
                    },
                    updated_by: {
                        displayName: 'Updated by',
                        type: Object,
                        get: getFullName,
                    },
                }),
            },
            accounts_team_approval: {
                default: {},
                type: new mongoose.Schema({
                    value: {
                        displayName: 'Accounts Team Approval',
                        type: Boolean,
                        default: false,
                    },
                    updated_date: {
                        displayName: 'Updated at',
                        type: Date,
                    },
                    updated_by: {
                        displayName: 'Updated by',
                        type: Object,
                        get: getFullName,
                    },
                }),
            },
            payment_id: {
                displayName: 'Beneficiary ID',
                helperText: 'Automatically added when a customer has completed account sort code & account no',
                type: String,
                default: '',
                set(value) {
                    return lodash.isEmpty(value.trim()) ? '' : value;
                },
            },
            chip_value: {
                displayName: 'Chip Value',
                type: Number,
            },
        }),
    },
    settlement_proof: {
        displayName: 'Settlement Proof',
        type: Object,
        isLoading: false,
        get: function getSettlementProff(value) {
            if (value && value._id) {
                return {
                    file: value,
                };
            }

            return value;
        },
    },
    // Is "Virtual field", not exists in DB
    tcard: {
        displayName: 'Add tCard to DMS',
        type: Boolean,
        default: false,
    },
});

leadFinanceSchema.method('turnInsideOut', turnInsideOut);



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/schemas/lead_finance.schema.js